import * as shapeValues from '@src/slide/application/service/menu-manager/menu-values/shape';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';

/**
 * 获取当前model所有的菜单属性对象
 * @param model
 */
export function getMenuValues(model: IChartModel): { [key: string]: any } {
    return shapeValues.getMenuValues(model as unknown as IShapeModel);
}
